import React from 'react';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';

import { WorkflowsTab } from './list/WorkflowsTable/filterWorkflows';

const WorkflowBuilder = React.lazy(() => import('./list/WorkflowBuilderPage'));
const WorkflowsList = React.lazy(() => import('./list/WorkflowsList'));
const WorkflowRedirect = React.lazy(() => import('./list/WorkflowRedirect'));
const WorkflowDashboard = React.lazy(
  () => import('./board/WorkflowDashboardPage'),
);
const WorkflowSettings = React.lazy(
  () => import('./settings/WorkflowSettingsPage'),
);
const StructureSettings = React.lazy(
  () => import('./settings/structure/StructureSettings'),
);
const BoardSettings = React.lazy(
  () => import('./settings/board/BoardSettings'),
);
const AutomationSettings = React.lazy(
  () => import('./settings/automation/AutomationSettings'),
);
const ProcessSettings = React.lazy(
  () => import('./settings/general/GeneralSettings'),
);

export default [
  {
    path: Pages.WORKFLOW_BUILDER,
    handle: { permissions: UserPermissions.ServiceWorkflowsRead },
    element: <WorkflowBuilder />,
    children: [
      { path: '', element: <WorkflowsList tab={WorkflowsTab.Published} /> },
      {
        path: Pages.WORKFLOW_DRAFTS,
        element: <WorkflowsList tab={WorkflowsTab.Drafts} />,
      },
    ],
  },
  {
    path: Pages.WORKFLOW_DASHBOARD,
    handle: { permissions: UserPermissions.ServiceWorkflowsRead },
    element: <WorkflowRedirect />,
  },
  {
    path: Pages.WORKFLOW_VERSION_DASHBOARD,
    handle: { permissions: UserPermissions.ServiceWorkflowsRead },
    element: <WorkflowDashboard />,
    children: [
      // A full-screen popup over the dashboard, so the board stays mounted
      // underneath and is current again once the popup closes.
      {
        path: Pages.WORKFLOW_SETTINGS,
        handle: { permissions: UserPermissions.ServiceWorkflowsRead },
        element: <WorkflowSettings />,
        // The popup's sections, picked in its sidebar.
        children: [
          { index: true, element: <StructureSettings /> },
          {
            path: Pages.WORKFLOW_SETTINGS_GENERAL,
            element: <ProcessSettings />,
          },
          {
            path: Pages.WORKFLOW_SETTINGS_BOARD,
            element: <BoardSettings />,
          },
          {
            path: Pages.WORKFLOW_SETTINGS_AUTOMATION,
            element: <AutomationSettings />,
          },
        ],
      },
    ],
  },
];
